/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_LintInputs */

const en_rd_check_lint = /** @type {(inputs: Rd_Check_LintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lint and format config`)
};

const id_rd_check_lint = /** @type {(inputs: Rd_Check_LintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurasi lint dan format`)
};

/**
* | output |
* | --- |
* | "Lint and format config" |
*
* @param {Rd_Check_LintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_lint = /** @type {((inputs?: Rd_Check_LintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_LintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_lint(inputs)
	return en_rd_check_lint(inputs)
});